<template>
  <div>
    <Header :loginState="loginState" @changeSuspendState="changeSuspendState"
      @changeLoginState="changeLoginState" @changeSuspendType="changeSuspendType"></Header>
    <div class="gift-bg"></div>
    <div class="gift-content-title">
      当前位置:
      <span><a @click="enterHome">平台首页</a> > </span>
      <span>礼包 </span>
    </div>
    <div class="gift-content-body">
      <div class="gift-left-body" v-show="!giftError">
        <ul style="margin-bottom: 25px;">
          <li class="gift-li" v-for="(item,index) in giftList" :key="index">
            <a :href="item.game_device == 1 ? '/webOfficial/'+item.game_tag : '/mobileOfficial/'+item.game_tag" target="_blank" class="gift-img">
              <img :src="baseImageAddress+'type=small&game_tag='+item.game_tag">
            </a>
            <div class="gift-box" :class="{giftHideActive : item.gift_expend_state == 1}">
              <h2>
                <a @click="enterGiftDetails(item.game_gid,0)">{{item.game_name}}</a>
              </h2>
              <dl v-for="(dl,index) in item.gifts" :key="index">
                <dt style="width: 505px;">
                  <h6><span class="pt">{{getGiftIcon(dl.gift_type)}}</span>{{dl.gift_name}}</h6>
                  <span class="gift-dt-span">
                    <em>礼包剩余: </em>
                    <Progress :percent="getPercent(dl.gift_count,dl.gift_max,0)" class="gift-progress-bar">
                      <span>{{getPercent(dl.gift_count,dl.gift_max,1)}}</span>
                    </Progress>
                  </span>
                  <p class="gift-dt-p">
                    <em>礼包内容: </em>
                    {{dl.gift_content}}
                  </p>
                </dt>
                <dd>
                  <a @click="enterGiftDetails(dl.game_gid,dl.gift_id)" 
                  target="_blank">领取</a>
                </dd>
              </dl>
            </div>
            <div class="gift-more" v-show="item.gift_expend_state != 2" 
              @click="enterGiftMore($event)">
              <a>查看更多礼包({{item.gift_expend_count}})<i></i></a>
            </div>
            <div class="gift-cb"></div>
          </li>
        </ul>
        <CommonPage v-if="showPageState" style="margin-bottom: 0;" class="center-game-page"
         :current.sync='giftBean.page' :page-size="giftBean.row" :total="giftTotal" show-total  show-elevator  @on-change="selectPage" prev-text="上一页" next-text="下一页"/>
      </div>
      <div class="gift-left-body" v-show="giftError">
        <span class="gift-empty">请等待礼包的上线!</span>
      </div>
      <RecommendSide :gift="gift" @searchByGameName="searchByGameName($event)"
        @searchByGameGid="searchByGameGid($event)"></RecommendSide>
    </div>
    <Footer></Footer>
    <SuspendSide></SuspendSide>
    <SuspendMember :suspendType="suspendType" :suspendState="suspendState"
      @changeSuspendState="changeSuspendState" @changeSuspendType="changeSuspendType"
      @changeLoginState="changeLoginState"></SuspendMember>
  </div>    
</template>
<script>
  import Footer from '../../components/common/Footer';
  import Header from '../../components/common/Header';
  import RecommendSide from '../../components/RecommendSide';
  import SuspendSide from '../../components/SuspendSide';
  import SuspendMember from '../../components/SuspendMember';
  import CommonPage from '../../components/CommonPage';
  export default {
    computed:{
      baseImageAddress(){
        return this.$store.state.constant.baseImageAddress;
      },
    },
    asyncData({store,route}){
      return store.dispatch('initSeo',{store:store});
    },
    data(){  
      return{
        gift:1,
        giftBean:{
          page:1,
          row:10,
          search:'',
          gid:''
        },
        suspendState:false,
        suspendType:0,
        loginState:false,
        isSelect:0,
        launchType:0,
        launchHref:"",
        showPageState:false,
        giftList:[],
        giftTotal:0,
        giftError:false,
      }
    },
    metaInfo(){
      return{
        title:"福利中心_"+this.$store.state.home.title,
        meta:[
          { name:'keywords', content:this.$store.state.home.keywords},
          { name:'description',content:this.$store.state.home.description}
        ]
      }
    },
    components:{ Footer, Header, RecommendSide, SuspendSide,SuspendMember, CommonPage},
    methods:{
      changeSuspendState(value){
        this.suspendState = value;
      },
      changeSuspendType(value){
        this.suspendType = value;
      },
      changeLoginState(value){
        this.loginState = value;
      },
      searchByGameName(value){
        this.isSelect = 1;
        this.giftBean.search = value;
        this.giftBean.gid = null;
        this.queryGift();
      },
      searchByGameGid(value){
        this.isSelect = 1;
        this.giftBean.search = null;
        this.giftBean.gid = value;
        this.queryGift();
      },
      enterHome(){
        this.$router.push({path:"/"});
      },
      enterGiftDetails(gid,lid){
        this.launchHref = this.$router.resolve({name:"giftDetails",query: {lid:lid,gid:gid}}).href
        if(this.loginState){
          window.open(this.launchHref,"_blank");
        }else{
          this.launchType = 1;
          this.enterLogin();
        }
      },
      enterLogin(){
        this.changeSuspendType(0);
        this.changeSuspendState(true);
      },
      queryGift(){
        this.$http.get('/query_all_gift',{params:this.giftBean}).then(res=>{
          if (res.data.code == 2000) {
            this.giftList = res.data.data;
            this.giftTotal = res.data.total;
            if(this.isSelect == 1){
              this.giftList.forEach((v, i) => {
                v.gift_expend_state = 2;
              });
            }
            if(this.giftTotal < 10){
              this.showPageState = false;
            }else{
              this.showPageState = true;
            }
            this.giftError = false;
          }else{
            this.giftError = true;
            this.giftList = [];
            this.giftTotal = 0;
          }
        })
      },
      selectPage(value){
        this.giftBean.page = value;
        this.queryGift();
      },
      enterGiftMore(e){
        e.currentTarget.previousElementSibling.className='gift-box';
        e.currentTarget.style.display = "none";
      },
      getGiftIcon(value){
        if(value == 1){
          return "积分";
        }else if(value == 2){
          return "平台币";
        }else if(value == 3){
          return "vip";
        }else if(value == 4){
          return "免费";
        }
      },
      getPercent(count,max,type) {
        if(count == undefined){
          count = 1;
        }
        if(max == undefined){
          max = 1;
        }
        let number = (max - count) / max * 100;
        if(type == 0){
          return number; 
        }else{
          if(number > 100){
            number = 100;
          }
          if(number < 0){
            number = 0;
          }
          return (number).toFixed(2)+"%";
        } 
      },
    },
    mounted(){ 
      this.queryGift();
    },
    watch:{
      loginState:function(value){
        if(value){
          if(this.launchType == 1){
            window.open(this.launchHref,"_blank");
          }
        }
      },
    },
  }
</script>
<style src="@/assets/css/gift.css" scoped></style>